import { ID } from "./table";

export enum APIAccountKeys {
  ID = "apiAccountId",
  NAME = "name",
  DESCRIPTION = "description",
  SOFTWARES_NAME = "softwares.Name",
  LAST_USED = "lastUsed",
  SOFTWARE = "software",
  ORGANISATION_ID = "organisationId",
  ORGANISATION_NAME = "organisationName",
}

export interface APIAccountListExtraInfo {
  id: ID;
  name: string;
}

export interface ExtendedAPIAccountList extends APIAccount {
  [APIAccountKeys.SOFTWARE]: APIAccountListExtraInfo;
  [APIAccountKeys.ORGANISATION_NAME]: string;
}

export interface APIAccount {
  [APIAccountKeys.ID]: string;
  [APIAccountKeys.NAME]: string;
  [APIAccountKeys.DESCRIPTION]: string;
  [APIAccountKeys.SOFTWARES_NAME]: string;
  [APIAccountKeys.LAST_USED]?: string;
  [APIAccountKeys.ORGANISATION_ID]: number;
}
